// extracted by mini-css-extract-plugin
export default {"badgeContainer":"Avatar_badgeContainer__a1kS8","verifiedBadge":"Avatar_verifiedBadge__HHDTK","verified":"Avatar_verified__UT74i","tooltip":"Avatar_tooltip__Ixsof"};